export const AddressPaneComponent = {
    template: `
        <oo-edit-pane
            is-editing="$ctrl.isEditing"
            on-submit="$ctrl.onSubmit()"
            on-cancel="$ctrl.resetForm()"
            on-error="$ctrl.onError(err)"
            on-delete="$ctrl.onDelete()"
        >
            <oo-read-state>
                <address-card address="$ctrl.address"></address-card>
            </oo-read-state>

            <oo-edit-state>
                <add-address address="$ctrl.editAddress" save="enabled"></add-address>
            </oo-edit-state>

            <oo-error-state>
                <address-suggestions
                    current-address="$ctrl.editAddress"
                    error="$ctrl.errors"
                    on-address-selection="$ctrl.setSuggestedAddress(address)">
                </address-suggestions>
            </oo-error-state>
        </oo-edit-pane>
    `,
    bindings: {
        address: '<',
        isEditing: '=?'
    },
    controller: class {
        constructor(accountService, $q, addressService, googleAnalyticsTrackingService) {
            'ngInject';
            this.accountService = accountService;
            this.$q = $q;
            this.addressService = addressService;
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
        }

        $onInit() {
            this.resetForm();
        }

        resetForm() {
            this.errors = {};
            this.editAddress = angular.copy(this.address);
        }

        onSubmit() {
            return this.addressService.validate(this.editAddress)
                .then(address => {
                    this.googleAnalyticsTrackingService.trackAddress('success');

                    this.accountService.updateAddress(address);
                    angular.merge(this.address, address);
                });
        }

        _updateAddress(address) {
            const permanent = true;
            return this.addressService.geocodeAddress(address, permanent)
                .then(
                    addr => this.accountService.updateAddress(Object.assign(address, addr)),
                    error => this.$q.reject(error)
                );
        }

        onError(err) {
            this.googleAnalyticsTrackingService.trackAddress('error');

            this.errors = err;
        }

        onDelete() {
            this.googleAnalyticsTrackingService.trackAddress('delete');

            this.accountService.deleteAddress(this.address.guid);
        }

        setSuggestedAddress(address) {
            this.editAddress = address;
            this.errors = {};
        }
    }
};
